import type { TemplateResult } from "lit";
import { html } from "lit";
import type { SocialLink, LegalLink } from "@ligonier/shared"
import { getSocialIcon, getSocialIconViewBox, sanitizeHeaderHref } from "@ligonier/shared"

export function renderTertiary(
  socialLinks: Array<SocialLink>,
  legalLinks: Array<LegalLink>,
  currentYear: number
): TemplateResult {
  return html`
    <div class="tertiary">
      <div class="container tertiary-container">
        <div class="tertiary-message">
          Interested in joining the Ligonier team? View our current
          <a href="https://careers.ligonier.org/">career opportunities.</a>
        </div>
        <div class="social-links">
          ${socialLinks.map(
            (social) => html`
              <a
                href="${sanitizeHeaderHref(social.url)}"
                title="${social.text}"
                class="social-link"
              >
                <svg class="social-icon" viewBox="${getSocialIconViewBox(social.icon)}">
                  <path d="${getSocialIcon(social.icon)}" />
                </svg>
              </a>
            `
          )}
        </div>
        <ul class="legal-links">
          ${legalLinks.map(
            (link, index) => html`
              <li style="display: contents;">
                ${index > 0 ? html`<span class="legal-separator"></span>` : ""}
                <a href="${sanitizeHeaderHref(link.url)}" class="legal-link">${link.label}</a>
              </li>
            `
          )}
        </ul>
        <div class="copyright">&copy;${currentYear} LIGONIER MINISTRIES</div>
      </div>
    </div>
  `;
}
